import SuggestionNode from '../store/schema/SuggestionNode';
import { ContentPosition, IEditor, PositionType } from 'roosterjs-editor-types';

export default function replaceSuggestionInEditorWithRealText(
    editor: IEditor,
    suggestionNode: SuggestionNode
) {
    if (suggestionNode?.suggestionNode && suggestionNode.suggestionNode.childNodes.length > 0) {
        const node = suggestionNode.suggestionNode;

        const textToInsert = node.childNodes.item(0).textContent.replace(' ', '\u00a0');
        const docfrag = document.createDocumentFragment();
        const arrayOfLines = textToInsert.split('\n');
        let finalElementInserted: Node;
        arrayOfLines.forEach((lineText, index) => {
            const textNode = document.createTextNode(lineText);
            docfrag.appendChild(textNode);
            finalElementInserted = textNode;
            if (index < arrayOfLines.length - 1) {
                const br = document.createElement('br');
                docfrag.appendChild(br);
            }
        });

        // Delete the suggestion node, and insert the actual text node
        editor.addUndoSnapshot();
        editor.deleteNode(node);
        editor.insertNode(docfrag, {
            position: ContentPosition.SelectionStart,
            updateCursor: false,
            replaceSelection: true,
            insertOnNewLine: false,
        });
        editor.addUndoSnapshot();

        // Move the cursor to the end of the newly inserted text
        editor.select(finalElementInserted, PositionType.End);
    }
}
